import * as React from 'react';


const Footer = () =>{
    return(
        <div className="container-fluid col-sm-12 team-s-block align-items-center text-center">
            <div>
            <div className="container footer-contact col-sm-6">
                <h3>VENHA NOS CONHECER</h3>
                <p>Av. República do Líbano, 331 - Ibirapuera - São Paulo-SP</p>
                <a href="https://goo.gl/maps/aySh8d1JAiv" target="_blank"><i className="fas fa-map-marker-alt fa-2x white"></i></a>
            </div>
            </div>
        </div>
    )
}

export default Footer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FooterComponent.tsx